import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import SeoManager from '@/components/feature/SeoManager';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LanguageRouter() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/pt-br')) {
      i18n.changeLanguage('pt-br');
    } else if (path.startsWith('/de')) {
      i18n.changeLanguage('de');
    } else if (path.startsWith('/en')) {
      i18n.changeLanguage('en');
    }
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <SeoManager />
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LanguageRouter />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;